import BlogDetailLeftSidebar from "../Blog/BlogDetailLeftSidebar";
import BlogDetailRightSidebar from "../Blog/BlogDetailRightSidebar";
import BlogLeftSidebar from "../Blog/BlogLeftSidebar";
import BlogList from "../Blog/BlogList";
import BlogRightSidebar from "../Blog/BlogRightSidebar";
import BlogDetails from "../Blog/Blogdetail";
import Home from "../Home";
import NotFound from "../Pages/404";
import ComingSoon from "../Pages/Commingsoon";
import DownloadPage from "../Pages/DownloadPage";
import Faq from "../Pages/FAQ";
import ForgetPassword from "../Pages/Forget-password";
import Request from "../Pages/Request";
import Review from "../Pages/Review";
import SignIn from "../Pages/SignIn";
import SignUp from "../Pages/SignUp";
import Thankyou from "../Pages/Thankyou";
import DemoApp from "../demo_page";

 

const routes = [
  { path: `${process.env.PUBLIC_URL}/`, element: <DemoApp /> },
  { path: `${process.env.PUBLIC_URL}/*`, element: <NotFound /> },
  { path: `${process.env.PUBLIC_URL}/home`, element: <Home /> },
  { path: `${process.env.PUBLIC_URL}/blog-details`, element: <BlogDetails /> },
  { path: `${process.env.PUBLIC_URL}/blog-list`, element: <BlogList /> },
  { path: `${process.env.PUBLIC_URL}/blog-leftside`, element: <BlogLeftSidebar /> },
  { path: `${process.env.PUBLIC_URL}/blog-rightside`, element: <BlogRightSidebar /> },
  { path: `${process.env.PUBLIC_URL}/blog-left-sidebar`, element: <BlogDetailLeftSidebar /> },
  { path: `${process.env.PUBLIC_URL}/blog-right-sidebar`, element: <BlogDetailRightSidebar /> },
  { path: `${process.env.PUBLIC_URL}/sign-in`, element: <SignIn /> },
  { path: `${process.env.PUBLIC_URL}/sign-up`, element: <SignUp /> },
  { path: `${process.env.PUBLIC_URL}/forget-password`, element: <ForgetPassword /> },
  { path: `${process.env.PUBLIC_URL}/thank-you`, element: <Thankyou /> },
  { path: `${process.env.PUBLIC_URL}/review`, element: <Review /> },
  { path: `${process.env.PUBLIC_URL}/faq`, element: <Faq /> },
  { path: `${process.env.PUBLIC_URL}/coming-soon`, element: <ComingSoon /> },
  { path: `${process.env.PUBLIC_URL}/download`, element: <DownloadPage /> },
  { path: `${process.env.PUBLIC_URL}/request`, element: <Request /> },
  { path: `${process.env.PUBLIC_URL}/404`, element: <NotFound /> }
];

export default routes;